import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { ContextNotification, severitys } from "../../../App";
import RtlProvider from '../../../Components/RtlProvider';
import AccessControl from '../../../Components/AccessControl';
import { ContextUserInfo } from "../../../Layout/MainLayout";
import ConfirmFlightPassenger from './ConfirmFlightPassenger';
import ConfirmFlight from './ConfirmFlight';
import AddPassengerToFlight from './AddPassengerToFlight';
import brokerGroupApi from '../../../api/brokerGroupApi';
import { GrCaretNext, GrCaretPrevious } from 'react-icons/gr';



export default function ConfirmFlightStepper({ row, isEdit, refresh }) {
    const steps = ['ثبت حضور زائران', 'افزودن به پرواز', 'تایید پرواز'];
    const { userInfo, userPermissions, userRoles } = React.useContext(ContextUserInfo);
    const { setOpen } = React.useContext(ContextNotification);
    const [activeStep, setActiveStep] = React.useState(0);

    React.useEffect(() => {
        handleReset();
    }
        , [row])
    const isStepOptional = (step) => {
        return (step === 1) || (isEdit);
    };
    const isStepFinal = (step) => {
        return (step === 2);
    };

    const handleNext = () => {
        if (!isStepFinal(activeStep)) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
        else {
            handleFinish();
        }

    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleSkip = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    const handleFinish = () => {
        setActiveStep(0);
        refresh();
    }


    const handleReset = () => {
        setActiveStep(0);
    };


    return (
        <Box sx={{ width: '100%' }}>
            <RtlProvider>
                <Stepper sx={{ mt: 2, mb: 3 }} activeStep={activeStep}>
                    {steps.map((label, index) => {

                        return (
                            <Step key={label} >
                                <StepLabel >{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>

                <Box sx={{
                    border: 'solid 2px #8aad9aff', borderRadius: 3 ,display: "flex",width:'100%',height:'100%',minHeight:300,
                    overflowY: "scroll",
                }}>

                    {(activeStep === 0) && (AccessControl.checkPermissions(userPermissions, ["Flight:CancelForFlightAndMembers"])) &&
                        <ConfirmFlightPassenger row={row} handleNextStep={() => handleNext()} />}
                    {(activeStep === 1) && (AccessControl.checkPermissions(userPermissions, ["Flight:ConfirmFlight"])) &&
                        <AddPassengerToFlight row={row} refresh={() => handleNext()} />}
                    {(activeStep === 2) && (AccessControl.checkPermissions(userPermissions, ["Flight:ConfirmFlight"])) &&
                        <ConfirmFlight row={row} resetForm={() => handleNext()} />}

                </Box>
                <React.Fragment>
                   <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    {(activeStep !==0)&&
                        <Button
                            color="primary"
                            onClick={handleBack}
                             style={{
                    fontSize: "16px",
                    width: "6rem",
                    height: "2.5rem",
                    background: 'linear-gradient(to left, #512674ff, #ffffff)',
                    color: "white",
                  }}
                        >
                            <GrCaretNext size={24}/>
{'قبلی'}                        </Button>}
                        <Box sx={{ flex: '1 1 auto' }} />
                        {isStepOptional(activeStep) && !isStepFinal(activeStep) && (
                            <Button color="inherit" onClick={handleSkip} style={{
                    fontSize: "16px",
                    width: "6rem",
                    height: "2.5rem",
                    background: 'linear-gradient(to right, #512674ff, #ffffff)',
                    color: "white",
      
                  }}>
                                {'بعدی'}
                                <GrCaretPrevious  size={24} />
                            </Button>
                        )}
                    </Box>
                </React.Fragment>
            </RtlProvider>
        </Box>
    );
}
